module.exports = __webpack_public_path__ + "../resources/img/ic_re_empty_document_img.0cf4d2fa.svg";